export function isChatroomMessageEditStorageFile({ file, storageFiles }) {
  return storageFiles.some(storageFile => storageFile.id === file.id)
}
